import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    styleUrl: './loading-indicator.component.scss'
})
export class LoadingIndicatorComponent implements OnInit {

    protected loaderIcon: string | null = null;

    private icons: string[] = [
        'fa-solid fa-hippo',
        'fa-solid fa-unicorn',
        'fa-solid fa-duck',
        'fa-solid fa-dog',
        'fa-solid fa-turtle',
        'fa-solid fa-fish',
        'fa-solid fa-horse',
        'fa-solid fa-pegasus',
        'fa-solid fa-t-rex'
    ];

    public ngOnInit(): void {
        const randomIndex = Math.floor(Math.random() * this.icons.length);
        this.loaderIcon = this.icons[randomIndex];
    }
}
